import { FC } from 'react';

export const ImageSnippet: FC<{ url: string }> = ({ url }) => (
  <img
    src={url}
    alt="snippet content"
    className="object-contain max-w-full max-h-full"
  />
);
